import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

interface SnackbarRecord {
  message: SnackbarMessage;
  timestamp: number;
}

const recentSnackbars = new Map<string, SnackbarRecord>();
const DEBOUNCE_TIME = 3000; // 3 seconds

export const enqueueUniqueSnackbar = (
  enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
  message: SnackbarMessage,
  options?: OptionsObject
) => {
  const key = `${message}-${options?.variant || 'default'}`;
  const now = Date.now();
  const existing = recentSnackbars.get(key);

  // Check if we've shown this message recently
  if (existing && (now - existing.timestamp) < DEBOUNCE_TIME) {
    return null; // Skip showing duplicate message
  }

  // Store this message
  recentSnackbars.set(key, {
    message,
    timestamp: now
  });

  // Clean up old messages
  for (const [storedKey, record] of recentSnackbars.entries()) {
    if (now - record.timestamp > DEBOUNCE_TIME) {
      recentSnackbars.delete(storedKey);
    }
  }

  // Show the message
  return enqueueSnackbar(message, options);
}; 